import { Pipe, PipeTransform } from '@angular/core';
import { REQUEST_ACTION } from 'src/app/core/constants/request-action.enum';

@Pipe({
    name: 'RequestAction'
})
export class RequestActionPipe implements PipeTransform {
    transform(action: any): any {
        switch (action) {
            case REQUEST_ACTION.OPERATION_ASSIGN:
                return 'operationAssignColor';
            case REQUEST_ACTION.OPERATION_REASSIGN:
                return 'operationReassignColor';
            case REQUEST_ACTION.CLOSE:
                return 'closeColor';
            case REQUEST_ACTION.RETURN:
                return 'returnColor';
            case REQUEST_ACTION.REVOKE:
                return 'revokeColor';
            case REQUEST_ACTION.OPERATION_COMPLETE:
                return 'operationCompleteColor';
            case REQUEST_ACTION.OPEN:
                return 'openColor';
            case REQUEST_ACTION.ASSIGN:
                return 'assignColor';
            case REQUEST_ACTION.OPERATION_OPEN:
                return 'operationOpenColor';
            default:
                return 'assignColor';
        }
    }
}
